import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { ChargesChartSearchCriteria, ChargesSearchCriteria } from './models/ChargesSearchCriteria';
import { ChargeCounterListDto, ChargeDto, ChartChargeDto, ChargeGeofenceDto, ChargeGeofenceListDto, ChargeValidationResult } from './models/ChargeDto';
import CustomFile from 'common/models/CustomFile';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { DetectChargeGeofenceViewModel } from './models/ChargeGeofenceDto';


class ChargesService {

    public getList(criteria: ChargesSearchCriteria) {
        return Http.get<Paged<ChargeDto>>('charges', criteria);
    }
    
    public catalog(criteria: ChargesSearchCriteria) {
        return Http.get<SelectValueLabel[]>('charges/catalog', criteria);
    }

    public getById(id: string) {
        return Http.get<ChargeDto>('charges/' + id);
    }
    
    public create(model: ChargeDto, attachment: CustomFile[]) {
        return Http.postWithFile<string>('charges', model, attachment);
    }

    public update(model: ChargeDto, attachment: CustomFile[]) {
        return Http.putWithFile<string>('charges', model, attachment);
    }

    // Task #66078: server-side validation of a manual expense before saving.
    public validate(model: { id?: string; vehicleId: string; date: Date; cost: number; liters?: number; kilometers?: number; fuelId?: string }) {
        return Http.post<ChargeValidationResult[]>('charges/validate', model);
    }

    public remove(model: ChargeDto) {
        return Http.put('charges/deactivate', model);
    }

    public getChartCharges(criteria: ChargesChartSearchCriteria) {
        return Http.get<ChartChargeDto>('charges/chart', criteria);
    }

    public getCountersList(criteria: ChargesSearchCriteria) {
        return Http.get<ChargeCounterListDto>('charges/counters-list', criteria);
    }

    public getGeofencesChargesCountersList(criteria: ChargesSearchCriteria) {
        return Http.get<ChargeCounterListDto>('charges/geofences-charges-counters-list', criteria);
    }
    
    public detectGeofences(model: DetectChargeGeofenceViewModel) {
        return Http.post<ChargeGeofenceDto[]>('charges/detect-geofences', model);
    }
    
    public changeChargeGeofences(model: ChargeGeofenceListDto) {
        return Http.post('charges/charge-geofences', model );
    }

    public fixDates(criteria: ChargesSearchCriteria) {
            if (criteria.startDate) {
                const year = criteria.startDate.getFullYear();
                const month = criteria.startDate.getMonth()+1;
                const day = criteria.startDate.getDate();
                criteria.startDate = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T00:00:00Z`);			
            }
            if (criteria.endDate) {
                const year = criteria.endDate.getFullYear();
                const month = criteria.endDate.getMonth()+1;
                const day = criteria.endDate.getDate();
                criteria.endDate = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T23:59:59Z`);
            }
            return criteria;
    }
}

export default new ChargesService();